import React from 'react';
import { Feedback } from 'services';
import { StyledTag } from 'components/shared/StyledTag';
import { getTheme, Stack } from '@fluentui/react';
import { getFeedbackTraitCount } from 'components/util';
import { borderBottomStyle } from '../../../../shared/BorderStyles';

interface EvidenceStats {
  feedback: Feedback[];
  className?: string;
}

export const EvidenceStats: React.FunctionComponent<EvidenceStats> = (props): JSX.Element => {
  const { palette } = getTheme();
  const borderBottom = borderBottomStyle(palette);
  const tags: { [id: string]: number } = getFeedbackTraitCount(props.feedback);
  // Tags sorted by occurence count
  const styledTags = Object.entries(tags)
    .sort((a, b) => b[1] - a[1])
    .map(([key, value]) => {
      return <StyledTag className="mr-1 mb-1" key={key} tag={`${key} (${value})`} />;
    });

  return (
    <Stack className="pb-4" style={borderBottom}>
      <Stack.Item className="pb-2">
        <span className="font-weight-bold">User Reported Traits</span>
      </Stack.Item>
      <Stack.Item grow>{styledTags}</Stack.Item>
    </Stack>
  );
};

export default EvidenceStats;
